<template>
  <div v-if="validations">
    <span
      v-for="(validation, index) in validations"
      :key="index"
      v-if="validation.condition"
      class="block cl-error h6"
      data-testid="errorMessage"
    >
      {{ validation.text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    validations: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.cl-error{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 4px;
  color: red;
  position: relative;
  z-index: 1;
  margin-top: 4px;
  margin-bottom: 12px;

  &::before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url("../../../../assets/icons/filled/cancel.svg") center center no-repeat;
    background-size: contain;
  }
}
</style>
